import { render, staticRenderFns } from "./MediaHero.vue?vue&type=template&id=da7f97d6&"
import script from "./MediaHero.vue?vue&type=script&lang=ts&"
export * from "./MediaHero.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports